<template>
    <div class="active-chat-notification-holder">
        <b-alert
            :show="activeChat.channel.platform === 'WHATSAPP' && !resolveCustomerCareWindow"
            class="active-chat-notification text-center round-large"
            variant="warning"
        >
            <div class="alert-body">
                <b-badge variant="warning">
                    <font-awesome-icon icon="bell" />
                </b-badge>

                <span>{{ $t("customer-care-window-closed") }} {{ $t("select-template-by-typing-slash") }}</span>
            </div>
        </b-alert>

        <b-alert
            :show="!!(activeChat.channel.platform === 'WHATSAPP' && resolveCustomerCareWindow)"
            class="active-chat-notification text-center round-large"
            variant="warning"
        >
            <div class="alert-body">
                <b-badge variant="warning">
                    <font-awesome-icon icon="bell" />
                </b-badge>

                <span>
                    {{
                        $t("customer-care-window-remaining", {
                            hours: resolveCustomerCareWindow.hours,
                            minutes: resolveCustomerCareWindow.minutes,
                            platform: $t(`platforms.${activeChat.channel.platform}`),
                        })
                    }}
                </span>
            </div>
        </b-alert>

        <b-alert
            :show="
                !isChatAssignedToMeV21(activeChat.lastConversation.assignedUserId) &&
                shouldAssignV21(activeChat.channel)
            "
            class="active-chat-notification assign d-flex justify-content-center round-large opacity-90"
        >
            <div class="alert-body d-flex align-items-center justify-content-center">
                <b-avatar class="mr-50" rounded size="30px" variant="primary">
                    <font-awesome-icon icon="user" size="1x" />
                </b-avatar>
                <small class="mr-2">{{ $t("chat-is-not-assigned") }}</small>
                <b-button
                    variant="primary"
                    @click="
                        $emit('assign-chat', {
                            id: activeChat.lastConversation.id,
                            channelId: activeChat.channel.id,
                            identityId: activeChat.lastConversation.identityId,
                            tags: activeChat.tags,
                            userId: getUserData().id,
                            status: activeChat.status,
                            teamId:
                                activeChat.lastConversation.assignedTeamId &&
                                isUserPartOfTeam(activeChat.lastConversation.assignedTeamId)
                                    ? activeChat.lastConversation.assignedTeamId
                                    : getRandomUserTeamForChannel(activeChat.channel.id),
                        })
                    "
                >
                    <span class="small font-weight-bold">{{ $t("chat-assign-to-me") }}</span>
                </b-button>
            </div>
        </b-alert>
    </div>
</template>

<script>
import { BAlert, BButton, BAvatar, BBadge } from "bootstrap-vue";
import { resolveRemainingCustomerCareWindow } from "@/utils/chats";
import { computed } from "@vue/composition-api/dist/vue-composition-api";
import { isChatAssignedToMeV21, shouldAssignV21 } from "@/utils/chats";
import { getUserData } from "@/auth/getUserData";
import useUsers from "@/composables/useUsers";

export default {
    components: {
        BAlert,
        BButton,
        BAvatar,
        BBadge,
    },
    props: {
        activeChat: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { isUserPartOfTeam, getRandomUserTeamForChannel } = useUsers();

        return {
            isChatAssignedToMeV21,
            shouldAssignV21,
            getUserData,
            getRandomUserTeamForChannel,
            isUserPartOfTeam,

            resolveCustomerCareWindow: computed(() =>
                resolveRemainingCustomerCareWindow(
                    props.activeChat.lastInboundMessageTime,
                    props.activeChat.channel.customerCareWindowLength
                )
            ),
        };
    },
};
</script>
